import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["tab", "panel"]
  static values = { notificationsUrl: String }

  switch(event) {
    const index = parseInt(event.params.index)
    const clickedTab = event.currentTarget

    this.tabTargets.forEach((tab, i) => {
      if (i === index) {
        tab.classList.add("text-amber-400", "border-b-2", "border-amber-500")
        tab.classList.remove("text-[#9ca3af]")
      } else {
        tab.classList.remove("text-amber-400", "border-b-2", "border-amber-500")
        tab.classList.add("text-[#9ca3af]")
      }
    })

    this.panelTargets.forEach((panel, i) => {
      panel.classList.toggle("hidden", i !== index)
    })

    if (clickedTab.dataset.notificationsTab) {
      this.loadNotifications()
    }

    if (clickedTab.dataset.leaderboardTab) {
      this.loadFrame("leaderboard-content")
    }
  }

  loadNotifications() {
    if (!this.hasNotificationsUrlValue) return
    const frame = document.getElementById("notifications-content")
    if (!frame) return
    if (!frame.src) {
      frame.src = this.notificationsUrlValue
    } else {
      frame.reload()
    }
  }

  loadFrame(frameId) {
    const frame = document.getElementById(frameId)
    if (!frame || !frame.src) return

    frame.reload()
  }
}
